import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetReferBookEntryDetail = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/ReferBookEntry/GetDetail?` + params, null, undefined, sToken);

export const GetReferBookEntryList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/ReferBookEntry/GetList?` + params, null);

export const CreateReferBookEntry = (data: any, sToken: string) =>
    POST_ENC(`${BASE_URL}/api/token/ReferBookEntry/Create`, data, false, undefined, sToken);

export const UpdateReferBookEntry = (data: any) =>
    POST_ENC(`${BASE_URL}/api/token/ReferBookEntry/Update`, data);

export const DeleteReferBookEntry = (data: any) =>
    POST_ENC(`${BASE_URL}/api/token/ReferBookEntry/Delete`, data);

export const GetLocationByToken = (params: any) =>
    GET_ENC(`${BASE_URL}/api/token/ReferBookEntry/GetLocationByToken?` + params, null);

export const GetReferBookTokenDetail = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/ReferBookEntry/GetReferBookTokenDetail?` + params, null, undefined, sToken);

export const GetAppointmentBookTokenDetail = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/ReferBookEntry/GetAppointmentBookTokenDetail?` + params, null, undefined, sToken);

export const GetReferBookEntryTokenDetail = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/ReferBookEntry/GetReferBookEntryTokenDetail?` + params, null, undefined, sToken);

export const GetPrescriptionTokenDetail = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/ReferBookEntry/GetPrescriptionTokenDetail?` + params, null, undefined, sToken);

export const GetReferBookAvailabilityDateList = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/ReferBookEntry/ReferBookAvailabilityDate?` + params, null, undefined, sToken);